import * as React from 'react';
import PageWrapper from "../../../common/atom/wrapper/page_wrapper";
import Progress from "../../../common/organism/progress";
import {TBreadcrumbItem} from "../../../type/common";
import {routeConfig} from "../../../../config/language/ja-JP/presentation/route_text";
import Breadcrumbs from "../../../common/molecular/breadcrumbs/breadcrumbs";
import styled from 'styled-components';
import HeadlineSmall from '../../../common/atom/text/headline_small';
import BtnLinkBorderSmall from 'src/presentation/common/atom/btn/btn_link_border_small';
import { ConstBreakPoint, ConstCalc, ConstColor } from 'src/config/styles_const/styles_const';
import CampaignQa from 'src/presentation/common/molecular/campaign/campaign-qa';
import CampaignSection from 'src/presentation/common/molecular/campaign/campaign-section-title';
import ParagraphSup from 'src/presentation/common/atom/text/paragraph_sup';
import Slider, {Settings} from "react-slick";
import { ClientBookmark } from 'src/domain/model/client_bookmark';
import SlideNextArrow from 'src/presentation/common/atom/slider_arrow/slide_next_arrow';
import SlidePrevArrow from 'src/presentation/common/atom/slider_arrow/slide_prev_arrow';
import SlideCustomerCard from '../top_page/slide_customer_card';
import { Customer } from 'src/domain/model/customer';
import { TJobCareerWithCustomerID } from 'src/domain/repository/job_career_repository';

interface IProps {
    pmCustomers: Customer[];
    toBPmCustomers: Customer[];
    toCPmCustomers: Customer[];
    bizdevPmCustomers: Customer[];
    growthPmCustomers: Customer[];
    pmmCustomers: Customer[];
    poCustomers: Customer[];
    jobCareersWithCustomerID: TJobCareerWithCustomerID[];
    clientBookmarks: ClientBookmark[];
    isLoading: boolean;
}

// breackpoint は調整必要
const settings: Settings = {
    className: "slider",
    dots: false,
    infinite: false,
    centerMode: false,
    swipeToSlide: true,
    variableWidth: true,
    arrows: true,
    prevArrow: <SlidePrevArrow />,
    nextArrow: <SlideNextArrow />,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
            }
        },
        {
            breakpoint: 650,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
            }
        },

        {
            breakpoint: 450,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        },
    ]
};

// breackpoint は調整必要
const sectionSettings: Settings = {
    className: "slider",
    dots: false,
    infinite: false,
    centerMode: false,
    swipeToSlide: true,
    variableWidth: true,
    arrows: true,
    prevArrow: <SlidePrevArrow />,
    nextArrow: <SlideNextArrow />,
    slidesToShow: 2,
    slidesToScroll: 2,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
            }
        },
        {
            breakpoint: 650,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
            }
        },

        {
            breakpoint: 450,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        },
    ]
};

const ClientPmCampaignComponent: React.FC<IProps> = (props) => {

    const {
        pmCustomers,
        toBPmCustomers,
        toCPmCustomers,
        bizdevPmCustomers,
        growthPmCustomers,
        pmmCustomers,
        poCustomers,
        jobCareersWithCustomerID, 
        clientBookmarks, 
        isLoading
    } = props;

    const breadcrumbItems: TBreadcrumbItem[] = [
        routeConfig.clientRoot,
        routeConfig.clientPmCampaign
    ]

    const res: JSX.Element = (
        <React.Fragment>
            {isLoading && <Progress canAnimation={false}/>}
            <PageWrapper>
                <Breadcrumbs breadcrumbItems={breadcrumbItems} />

                <CampaignQa
                    q="Q. PMはどんな職業なのでしょうか？"
                    a="PMは、大きくプロジェクトマネージャーとプロダクトマネージャーの2つの役割を指すケースが多いです。
                    前者はPjM、後者はPdMと日本では区別されるケースがあります。
                    もしプロジェクトマネージャーをお探しの場合は、以下にプロジェクトマネージャーをPick Upしました。"
                />

                <PmWrapper>
                    <SubTitleWrapper>
                        <HeadlineSmall>プロジェクトマネージャー</HeadlineSmall>
                        <BtnLinkBorderSmall to={`/client/scout/customers?q=プロジェクトマネージャー&p=1`}>もっと見る</BtnLinkBorderSmall>
                    </SubTitleWrapper>

                    <SliderWrapper>
                        <Slider {...settings}>
                            {pmCustomers.map((customer, index) => {
                                const jobCareerWithCustomerID = jobCareersWithCustomerID.find((_jobCareerWithCustomerID) => {
                                    return _jobCareerWithCustomerID.customerID === customer.id
                                })
                                const jobCareers = jobCareerWithCustomerID ? jobCareerWithCustomerID.jobCareers : []
                                const isBookmarked: boolean = clientBookmarks.some((clientBookmark:ClientBookmark) => {
                                    return clientBookmark.customerID === customer.id
                                });

                                return (
                                    <SlideCustomerWrapper key={`${customer.id}-${index}`} style={{width: 200}}>
                                        <SlideCustomerCard
                                            customer={customer}
                                            jobCareers={jobCareers}
                                            isBookmarked={isBookmarked}
                                        />
                                    </SlideCustomerWrapper>
                                )
                            })}
                        </Slider>
                    </SliderWrapper>
                </PmWrapper>

                <CampaignQa
                    q="Q. どんなプロダクトマネージャーを採用すれば良いのでしょうか？"
                    a="プロダクトマネージャーの役割や業務定義は、企業毎に異なる傾向にあります。
                    決まったはいものの、上手くFitしないケースも多くあり、自社に決まったPMを獲得する事は簡単ではありません。
                    ここでは上記の課題に対して、体系立てたPMの探し方をご紹介します。"
                />

                <CampaignSection
                    index={"1"}
                    title={"toB型か、toC型か？"}
                    text={"プロダクトマネージャーは、これで大きく２分されます。もちろん両方を経験してるPMもいますが、基本的にはどちらか一方の専門性を持った方が多いです。toBだとプライシングの設計や、顧客折衝、大型顧客対応など、toCだとKPIモニタリング、アナリシス、キャンペーン対応等それぞれ専門領域が異なります。"}
                />

                <CardsFlexWrapper>
                    <CardWrapper>
                        <SubTitleWrapper>
                            <HeadlineSmall>toB型のPM</HeadlineSmall>
                            <BtnLinkBorderSmall to={`/client/scout/customers?q=プロダクトマネージャー　BtoB&p=1`}>もっと見る</BtnLinkBorderSmall>
                        </SubTitleWrapper>

                        <SliderWrapper>
                            <Slider {...sectionSettings}>
                                {toBPmCustomers.map((customer, index) => {
                                    const jobCareerWithCustomerID = jobCareersWithCustomerID.find((_jobCareerWithCustomerID) => {
                                        return _jobCareerWithCustomerID.customerID === customer.id
                                    })
                                    const jobCareers = jobCareerWithCustomerID ? jobCareerWithCustomerID.jobCareers : []
                                    const isBookmarked: boolean = clientBookmarks.some((clientBookmark:ClientBookmark) => {
                                        return clientBookmark.customerID === customer.id
                                    });

                                    return (
                                        <SectionSlideCustomerWrapper key={`${customer.id}-${index}`} style={{width: 200}}>
                                            <SlideCustomerCard
                                                customer={customer}
                                                jobCareers={jobCareers}
                                                isBookmarked={isBookmarked}
                                            />
                                        </SectionSlideCustomerWrapper>
                                    )
                                })}
                            </Slider>
                        </SliderWrapper>

                    </CardWrapper>

                    <CardWrapper>
                        <SubTitleWrapper>
                            <HeadlineSmall>toC型のPM</HeadlineSmall>
                            <BtnLinkBorderSmall to={`/client/scout/customers?q=プロダクトマネージャー　toC&p=1`}>もっと見る</BtnLinkBorderSmall>
                        </SubTitleWrapper>

                        <SliderWrapper>
                            <Slider {...sectionSettings}>
                                {toCPmCustomers.map((customer, index) => {
                                    const jobCareerWithCustomerID = jobCareersWithCustomerID.find((_jobCareerWithCustomerID) => {
                                        return _jobCareerWithCustomerID.customerID === customer.id
                                    })
                                    const jobCareers = jobCareerWithCustomerID ? jobCareerWithCustomerID.jobCareers : []
                                    const isBookmarked: boolean = clientBookmarks.some((clientBookmark:ClientBookmark) => {
                                        return clientBookmark.customerID === customer.id
                                    });

                                    return (
                                        <SectionSlideCustomerWrapper key={`${customer.id}-${index}`} style={{width: 200}}>
                                            <SlideCustomerCard
                                                customer={customer}
                                                jobCareers={jobCareers}
                                                isBookmarked={isBookmarked}
                                            />
                                        </SectionSlideCustomerWrapper>
                                    )
                                })}
                            </Slider>
                        </SliderWrapper>

                    </CardWrapper>
                </CardsFlexWrapper>

                <CampaignSection
                    index={"2"}
                    title={"新規事業タイプか、グロースハックタイプか"}
                    text={"こちらもプロダクトマネージャーの役割で次点にくる区分になります。toB型は新規事業タイプが多い傾向で、toC型はグロースハックタイプが多い傾向にあります。新規事業タイプのPMは、アイデアの起案からリーンキャンバス、プロトタイプ検証、PMF検証などを実務で行う傾向にあり、グロースハックタイプはKPIモニタリングや、プロダクトブラシュアップのためのフロー設計などを行う傾向にあります。自社で求めているタイプと、そのプロダクトのどこに課題感を持っているのかを考えるとGapが生じづらいです。"}
                />

                <CardsFlexWrapper>
                    <CardWrapper>
                        <SubTitleWrapper>
                            <HeadlineSmall>新規事業タイプのPM</HeadlineSmall>
                            <BtnLinkBorderSmall to={`/client/scout/customers?q=新規事業　PM&p=1`}>もっと見る</BtnLinkBorderSmall>
                        </SubTitleWrapper>

                        <SliderWrapper>
                            <Slider {...sectionSettings}>
                                {bizdevPmCustomers.map((customer, index) => {
                                    const jobCareerWithCustomerID = jobCareersWithCustomerID.find((_jobCareerWithCustomerID) => {
                                        return _jobCareerWithCustomerID.customerID === customer.id
                                    })
                                    const jobCareers = jobCareerWithCustomerID ? jobCareerWithCustomerID.jobCareers : []
                                    const isBookmarked: boolean = clientBookmarks.some((clientBookmark:ClientBookmark) => {
                                        return clientBookmark.customerID === customer.id
                                    });

                                    return (
                                        <SectionSlideCustomerWrapper key={`${customer.id}-${index}`} style={{width: 200}}>
                                            <SlideCustomerCard
                                                customer={customer}
                                                jobCareers={jobCareers}
                                                isBookmarked={isBookmarked}
                                            />
                                        </SectionSlideCustomerWrapper>
                                    )
                                })}
                            </Slider>
                        </SliderWrapper>

                    </CardWrapper>

                    <CardWrapper>
                        <SubTitleWrapper>
                            <HeadlineSmall>グロースハックタイプのPM</HeadlineSmall>
                            <BtnLinkBorderSmall to={`/client/scout/customers?q=グロースハック　PM&p=1`}>もっと見る</BtnLinkBorderSmall>
                        </SubTitleWrapper>

                        <SliderWrapper>
                            <Slider {...sectionSettings}>
                                {growthPmCustomers.map((customer, index) => {
                                    const jobCareerWithCustomerID = jobCareersWithCustomerID.find((_jobCareerWithCustomerID) => {
                                        return _jobCareerWithCustomerID.customerID === customer.id
                                    })
                                    const jobCareers = jobCareerWithCustomerID ? jobCareerWithCustomerID.jobCareers : []
                                    const isBookmarked: boolean = clientBookmarks.some((clientBookmark:ClientBookmark) => {
                                        return clientBookmark.customerID === customer.id
                                    });

                                    return (
                                        <SectionSlideCustomerWrapper key={`${customer.id}-${index}`} style={{width: 200}}>
                                            <SlideCustomerCard
                                                customer={customer}
                                                jobCareers={jobCareers}
                                                isBookmarked={isBookmarked}
                                            />
                                        </SectionSlideCustomerWrapper>
                                    )
                                })}
                            </Slider>
                        </SliderWrapper>

                    </CardWrapper>
                </CardsFlexWrapper>

                <CampaignSection
                    index={"3"}
                    title={"PMMとPMとPO"}
                    text={"冒頭で書いた企業ごとに役割が異なる中で、広義にPM、狭義にPMM、PM、POと定義されるケースがあります。もし自社の課題感が狭義の役割にFitする場合は、その専門家を選択することが望ましいです。PMMはプロダクトマーケティングマネージャーで、よくtoB型のSaaS企業で活躍しています。役割は主に、マーケットに対していかにアプローチしていくかを考える仕事ですので、プライシングやカスタマーヒアリングなどが中心の活動になります。PMはPMMと一緒になり新機能を考え、設計(PRD)に落とし込んでいく作業がメインになります。POはスクラム 開発の役割で、スクラムチームの成功に責任を負います。"}
                />

                <CardsFlexWrapper>
                    <CardWrapper>
                        <SubTitleWrapper>
                            <HeadlineSmall>PMM</HeadlineSmall>
                            <BtnLinkBorderSmall to={`/client/scout/customers?q=プロダクトマーケティング&p=1`}>もっと見る</BtnLinkBorderSmall>
                        </SubTitleWrapper>

                        <SliderWrapper>
                            <Slider {...sectionSettings}>
                                {pmmCustomers.map((customer, index) => {
                                    const jobCareerWithCustomerID = jobCareersWithCustomerID.find((_jobCareerWithCustomerID) => {
                                        return _jobCareerWithCustomerID.customerID === customer.id
                                    })
                                    const jobCareers = jobCareerWithCustomerID ? jobCareerWithCustomerID.jobCareers : []
                                    const isBookmarked: boolean = clientBookmarks.some((clientBookmark:ClientBookmark) => {
                                        return clientBookmark.customerID === customer.id
                                    });

                                    return (
                                        <SectionSlideCustomerWrapper key={`${customer.id}-${index}`} style={{width: 200}}>
                                            <SlideCustomerCard
                                                customer={customer}
                                                jobCareers={jobCareers}
                                                isBookmarked={isBookmarked}
                                            />
                                        </SectionSlideCustomerWrapper>
                                    )
                                })}
                            </Slider>
                        </SliderWrapper>

                    </CardWrapper>

                    <CardWrapper>
                        <SubTitleWrapper>
                            <HeadlineSmall>PO（プロダクトオーナー）</HeadlineSmall>
                            <BtnLinkBorderSmall to={`/client/scout/customers?q=プロダクトオーナー&p=1`}>もっと見る</BtnLinkBorderSmall>
                        </SubTitleWrapper>

                        <SliderWrapper>
                            <Slider {...sectionSettings}>
                                {poCustomers.map((customer, index) => {
                                    const jobCareerWithCustomerID = jobCareersWithCustomerID.find((_jobCareerWithCustomerID) => {
                                        return _jobCareerWithCustomerID.customerID === customer.id
                                    })
                                    const jobCareers = jobCareerWithCustomerID ? jobCareerWithCustomerID.jobCareers : []
                                    const isBookmarked: boolean = clientBookmarks.some((clientBookmark:ClientBookmark) => {
                                        return clientBookmark.customerID === customer.id
                                    });

                                    return (
                                        <SectionSlideCustomerWrapper key={`${customer.id}-${index}`} style={{width: 200}}>
                                            <SlideCustomerCard
                                                customer={customer}
                                                jobCareers={jobCareers}
                                                isBookmarked={isBookmarked}
                                            />
                                        </SectionSlideCustomerWrapper>
                                    )
                                })}
                            </Slider>
                        </SliderWrapper>

                    </CardWrapper>
                </CardsFlexWrapper>

                <CampaignMessageWrapper>
                    <HeadlineSmall>
                        さいごに
                    </HeadlineSmall>
                    <ParagraphSup bold={true}>
                        EXPERT NETWORKでは、プロダクトマネージャーの選定にお困りの企業からのご相談をお待ちしております。お気軽に担当営業までご相談ください。
                    </ParagraphSup>
                </CampaignMessageWrapper>

            </PageWrapper>
        </React.Fragment>

    );

    return (res);

};

export default ClientPmCampaignComponent;

const PmWrapper = styled.div`
    margin-bottom: 70px;
    width: 100%;
`

const SubTitleWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    
    margin-bottom: 15px;
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        margin-bottom: 30px;
    }
`

const CardsFlexWrapper = styled.div`
    display: block;
    width: 100%;
    border-bottom: 1px solid ${ConstColor.LightGray};
    margin-bottom: 45px;
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        display: flex;
    }
`

const CardWrapper = styled.div`
    width: 100%;
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        width: 45%;
        margin-right: 5%;
    }
`

const CampaignMessageWrapper = styled.div`
    background-color: ${ConstColor.GreenGray};
    padding: 20px 25px;
    width: 100%;
`

const SliderWrapper = styled.div`
    margin-bottom: 40px;
    
    // react-slickの横幅の計算がうまく働いていないのでここで決めている感じ
    max-width: ${ConstCalc.CustomerSlideMaxWidthSp};
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        margin-bottom: 40px;
        max-width: ${ConstCalc.CustomerSlideMaxWidthTablet};
    }
    @media screen and (min-width: ${ConstBreakPoint.PcDeskTop}) {
        max-width: ${ConstCalc.CustomerSlideMaxWidthPc};
    }

    // 一部で縦の大きさが変動していたため固定する
    & .slick-slider {
        height: 334px;
    }
`

const SlideCustomerWrapper = styled.div`
    padding: 5px 15px;
`

const SectionSlideCustomerWrapper = styled.div`
    padding: 5px 15px 5px 5px;
`


// WEBPACK FOOTER //
// ./src/presentation/component/client/campaign/client_pm_campaign.tsx